'use client';

import { SectLabel, V4CtaButton, V4GhostButton } from '@/components/landing/v4-shared';
import { MagneticCta } from '@/components/marketing/MagneticCta';
import { BLOG_SLUG_COPY, BRAND } from '@/lib/marketing/messaging-bank';

/**
 * Article-page final CTA strip. Cyan-pillar Aurora paint, magnetic-feel
 * cursor on the primary CTA via the shared MagneticCta primitive
 * (motion-gated by `prefers-reduced-motion`).
 */
export function BlogFinalCta() {
  const section = BLOG_SLUG_COPY.sections.find((s) => s.id === 'final-cta');

  return (
    <section
      className="blog-section blog-section--final-cta"
      aria-labelledby="final-cta-heading"
    >
      <div className="blog-section__inner blog-section__inner--narrow">
        {section?.eyebrow && <SectLabel color="var(--cyan-glow)">{section.eyebrow}</SectLabel>}
        <h2 id="final-cta-heading" className="blog-final-cta__heading">
          {section?.heading ?? 'Automate every inbound business call.'}
        </h2>
        <p className="blog-final-cta__body">
          {section?.body ??
            `Deploy your AI receptionist in under ${BRAND.setupTimeClaim}. 30-day guarantee. Cancel anytime.`}
        </p>
        <div className="blog-final-cta__row">
          <MagneticCta>
            <V4CtaButton href={BLOG_SLUG_COPY.ctaPrimary.href} size="lg">
              {BLOG_SLUG_COPY.ctaPrimary.label}
            </V4CtaButton>
          </MagneticCta>
          {BLOG_SLUG_COPY.ctaSecondary && (
            <V4GhostButton href={BLOG_SLUG_COPY.ctaSecondary.href} variant="cyan" size="lg">
              {BLOG_SLUG_COPY.ctaSecondary.label}
            </V4GhostButton>
          )}
        </div>
        <p
          style={{
            marginTop: 18,
            fontFamily: 'var(--font-geist-mono)',
            fontSize: 11,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            color: 'var(--dim)',
          }}
        >
          {BRAND.primaryCtaShort}
        </p>
      </div>
    </section>
  );
}
